import React from "react";
import { VegaFont } from "@heartlandone/vega-react";
import { ACTIVITY_STATUS } from "Chore/Constants";

function ActivityTitle({ state, title }) {
  const textStyle = {
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis"
  };
  return (
    <VegaFont
      color={
        state === ACTIVITY_STATUS.STATUS_LABEL.CLOSED
          ? "text-secondary"
          : "text-primary"
      }
      variant="font-h5"
      style={textStyle}
    >
      {title}
    </VegaFont>
  );
}

export default ActivityTitle;
